import { useAuth } from '../context/AuthContext';

// I permessi arrivano da /api/auth/me; il controllo vero è sempre nel backend.
export function puoAccedere(utente, sezione, livello = 'lettura') {
  const concesso = utente?.permessi?.[sezione];
  if (!concesso) return false;
  return livello === 'lettura' || concesso === 'scrittura';
}

// Hook: true se l'utente collegato può scrivere nella sezione (per nascondere i pulsanti)
export function usePuoScrivere(sezione) {
  const { utente } = useAuth();
  return puoAccedere(utente, sezione, 'scrittura');
}
